import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { closeModal } from '../../reducers/modal'

// don't remove! needed to prevent flickering during animation in Safari..
const extraContent = (
  <button
    style={{
      visibility: 'hidden',
      background: 'none',
      padding: '0px',
      // Safari - flicker appears unless this element takes up some space,
      // but strangely enough doesnt work to set height+weight, but just border..
      // and transparent border doesnt work either, so use semi-transparent
      border: '0.5px solid rgba(255,255,255,0.01)',
      margin: '0px -2px 0px 0px',
      pointerEvents: 'none'
    }}
  />
)

const Modal = class Modal extends Component {
  render () {
    const { isActive, content, closeModal, extraClass } = this.props
    const classes = classnames(
      {
        'modal--active': isActive
      },
      extraClass,
      'modal'
    )
    return (
      <div className={classes} role='dialog' onClick={closeModal}>
        {extraContent}
        <div
          className='modal__dialog'
          role='document'
          onClick={e => {
            e.nativeEvent.stopImmediatePropagation() // Prevent click bubbling and closing modal
            e.stopPropagation()
          }}
        >
          <button
            type='button'
            className='button button--plain modal__close'
            onClick={closeModal}
          >
            ✕
          </button>
          <div className='modal__content'>{content}</div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  content: PropTypes.node,
  extraClass: PropTypes.string
}

const mapStateToProps = ({ modal: { isActive, content, extraClass } }) => {
  return { isActive, content, extraClass }
}

export default connect(mapStateToProps, { closeModal })(Modal)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Modal.js